// removed by extract-text-webpack-plugin
module.exports = {"popup":"_2U7P6XP3EBlYHFmn","fade":"_1AeDNzS5GEA6LLm8","containerWrapper":"_3Aqe-ephRcxT8HY_","container":"XiLhIsWPNFbZl_GY","autoSize":"_1W-QvqbqTbGocphl"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/Popup.pcss
// module id = 488
// module chunks = 1